/**
 * SKU表格列定义
 * 职责: 定义SKU列表的表格列配置
 * 限制: <100行
 */

import { Button, Space } from 'antd';
import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import type { SKU } from '../../types';

export const createSKUColumns = (
    onView: (id: number) => void,
    onEdit: (sku: SKU) => void,
    onDelete: (id: number) => void
) => [
        {
            title: 'SKU名称',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'ASIN',
            dataIndex: 'asin',
            key: 'asin',
        },
        {
            title: '周期数',
            dataIndex: 'periods_count',
            key: 'periods_count',
        },
        {
            title: '活跃权重配置',
            dataIndex: 'active_weight_config_name',
            key: 'active_weight_config_name',
            render: (text: string) => text || '-',
        },
        {
            title: '创建时间',
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text: string) => new Date(text).toLocaleDateString(),
        },
        {
            title: '操作',
            key: 'actions',
            render: (_: any, record: SKU) => (
                <Space>
                    <Button
                        type="link"
                        icon={<EyeOutlined />}
                        onClick={() => onView(record.id)}
                    >
                        查看
                    </Button>
                    <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => onEdit(record)}
                    >
                        编辑
                    </Button>
                    <Button
                        type="link"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => onDelete(record.id)}
                    >
                        删除
                    </Button>
                </Space>
            ),
        },
    ];
